module.exports = __webpack_public_path__ + "img/register.ba3e90c1.png";